import { itemServices } from 'src/services/reservation/item/item.service'
import { customAwait } from 'src/components/pages/sales/reservation/helper/customAwait'

type Refresh = () => void

interface approveRefuseDebinPaymentParams {
  hashItemReserve: string
  approveDebin: boolean
  refresh: Refresh
  notify: any
  setLoadingDebinItem: React.Dispatch<React.SetStateAction<boolean>>
  setHashItemReserve: React.Dispatch<React.SetStateAction<string>>
  setConfirmDebin: React.Dispatch<React.SetStateAction<boolean>> | undefined
  setOpenDebinModal: React.Dispatch<React.SetStateAction<boolean>> | undefined
}

export const approveRefuseDebinPayment  = async ({
  hashItemReserve,
  approveDebin,
  refresh,
  notify,
  setHashItemReserve,
  setLoadingDebinItem,
  setConfirmDebin,
  setOpenDebinModal
}: approveRefuseDebinPaymentParams): Promise<void> => {
  try {
    setLoadingDebinItem(true)
    setOpenDebinModal && setOpenDebinModal(false)
    const response = await (approveDebin
      ? itemServices.approve_debin_payment(hashItemReserve)
      : itemServices.refuse_debin_payment(hashItemReserve)
    )
    if (response) {
      notify(approveDebin
        ? 'Pago DEBIN aprobado correctamente'
        : 'Pago DEBIN rechazado correctamente',
        { type: 'success' }
      )
      setHashItemReserve('')
      setLoadingDebinItem(false)
      setConfirmDebin && setConfirmDebin(false)
      return
    }
    setHashItemReserve('')
    setConfirmDebin && setConfirmDebin(false)
    setLoadingDebinItem(false)
    notify(approveDebin
      ? 'Error al aprobar pago DEBIN'
      : 'Error al rechazar pago DEBIN',
      { type: 'error' }
    )
  } catch (error: any) {
    notify(approveDebin
      ? 'Error al aprobar pago DEBIN'
      : 'Error al rechazar pago DEBIN',
      { type: 'error' }
    )
    setOpenDebinModal && setOpenDebinModal(false)
    setHashItemReserve('')
    setLoadingDebinItem(false)
    setConfirmDebin && setConfirmDebin(false)
  } finally {
    customAwait([refresh])
  }
}